import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sorting_asc",
  "use": "sorting_asc-usage",
  "viewBox": "0 0 8 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8 9\" id=\"sorting_asc\"><path d=\"M.8 5.2c.4.4 1 .4 1.4 0l.8-.8V8c0 .6.4 1 1 1s1-.4 1-1V4.4l.8.8c.4.4 1 .4 1.4 0s.4-1 0-1.4L4 .6.8 3.8c-.4.4-.4 1 0 1.4\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol